import { render, staticRenderFns } from "./IconPeople.vue?vue&type=template&id=b7b01918"
import script from "./IconPeople.vue?vue&type=script&lang=js"
export * from "./IconPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports